// source: courses.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var enum_pb = require('./enum_pb.js');

goog.object.extend(proto, enum_pb);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');

goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.manabie.bob.Chapter', null, global);
goog.exportSymbol('proto.manabie.bob.Completenes', null, global);
goog.exportSymbol('proto.manabie.bob.GetChapterListRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetChapterListResponse', null, global);
goog.exportSymbol('proto.manabie.bob.GetHistoryQuizDetailRequest', null, global);
goog.exportSymbol('proto.manabie.bob.GetHistoryQuizDetailResponse', null, global);
goog.exportSymbol('proto.manabie.bob.LearningObjective', null, global);
goog.exportSymbol('proto.manabie.bob.ListTopicRequest', null, global);
goog.exportSymbol('proto.manabie.bob.ListTopicResponse', null, global);
goog.exportSymbol('proto.manabie.bob.ListTopicsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.ListTopicsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.ListTopicsResponse.Data', null, global);
goog.exportSymbol('proto.manabie.bob.LocalGrade', null, global);
goog.exportSymbol('proto.manabie.bob.PresetStudyPlan', null, global);
goog.exportSymbol('proto.manabie.bob.PresetStudyPlanWeekly', null, global);
goog.exportSymbol('proto.manabie.bob.PublishTopicsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.PublishTopicsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.Question', null, global);
goog.exportSymbol('proto.manabie.bob.QuizSets', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCoursesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCoursesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveCoursesResponse.Course', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveGradeMapRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveGradeMapResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveLORequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveLOResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveSubmissionHistoryRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveSubmissionHistoryResponse', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveTopicsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.RetrieveTopicsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.SubmissionHistory', null, global);
goog.exportSymbol('proto.manabie.bob.SubmissionResult', null, global);
goog.exportSymbol('proto.manabie.bob.SuggestLORequest', null, global);
goog.exportSymbol('proto.manabie.bob.SuggestLOResponse', null, global);
goog.exportSymbol('proto.manabie.bob.TakeTheQuizRequest', null, global);
goog.exportSymbol('proto.manabie.bob.TakeTheQuizResponse', null, global);
goog.exportSymbol('proto.manabie.bob.Topic', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertLOsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertLOsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertPresetStudyPlansRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertPresetStudyPlansResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertQuestionsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertQuestionsResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertQuizRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertQuizResponse', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertTopicsRequest', null, global);
goog.exportSymbol('proto.manabie.bob.UpsertTopicsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.manabie.bob.ListTopicRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ListTopicRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListTopicRequest.displayName = 'proto.manabie.bob.ListTopicRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ListTopicResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.ListTopicResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.ListTopicResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListTopicResponse.displayName = 'proto.manabie.bob.ListTopicResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ListTopicsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ListTopicsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListTopicsRequest.displayName = 'proto.manabie.bob.ListTopicsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ListTopicsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.ListTopicsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.ListTopicsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListTopicsResponse.displayName = 'proto.manabie.bob.ListTopicsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.ListTopicsResponse.Data = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.ListTopicsResponse.Data, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.ListTopicsResponse.Data.displayName = 'proto.manabie.bob.ListTopicsResponse.Data';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Topic = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.Topic, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Topic.displayName = 'proto.manabie.bob.Topic';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveLORequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveLORequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveLORequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveLORequest.displayName = 'proto.manabie.bob.RetrieveLORequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Completenes = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.Completenes, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Completenes.displayName = 'proto.manabie.bob.Completenes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveLOResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveLOResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveLOResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveLOResponse.displayName = 'proto.manabie.bob.RetrieveLOResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Question = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Question.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Question, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Question.displayName = 'proto.manabie.bob.Question';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.LearningObjective = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.LearningObjective.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.LearningObjective, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.LearningObjective.displayName = 'proto.manabie.bob.LearningObjective';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.QuizSets = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.QuizSets, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.QuizSets.displayName = 'proto.manabie.bob.QuizSets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveTopicsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveTopicsRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveTopicsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveTopicsRequest.displayName = 'proto.manabie.bob.RetrieveTopicsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveTopicsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveTopicsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveTopicsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveTopicsResponse.displayName = 'proto.manabie.bob.RetrieveTopicsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertTopicsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertTopicsRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertTopicsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertTopicsRequest.displayName = 'proto.manabie.bob.UpsertTopicsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertTopicsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertTopicsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertTopicsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertTopicsResponse.displayName = 'proto.manabie.bob.UpsertTopicsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertLOsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertLOsRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertLOsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertLOsRequest.displayName = 'proto.manabie.bob.UpsertLOsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertLOsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertLOsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertLOsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertLOsResponse.displayName = 'proto.manabie.bob.UpsertLOsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.SubmissionResult = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.SubmissionResult, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.SubmissionResult.displayName = 'proto.manabie.bob.SubmissionResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveSubmissionHistoryRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveSubmissionHistoryRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveSubmissionHistoryRequest.displayName = 'proto.manabie.bob.RetrieveSubmissionHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.SubmissionHistory = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.SubmissionHistory.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.SubmissionHistory, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.SubmissionHistory.displayName = 'proto.manabie.bob.SubmissionHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveSubmissionHistoryResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveSubmissionHistoryResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveSubmissionHistoryResponse.displayName = 'proto.manabie.bob.RetrieveSubmissionHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.TakeTheQuizRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.TakeTheQuizRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.TakeTheQuizRequest.displayName = 'proto.manabie.bob.TakeTheQuizRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.TakeTheQuizResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.TakeTheQuizResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.TakeTheQuizResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.TakeTheQuizResponse.displayName = 'proto.manabie.bob.TakeTheQuizResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertQuestionsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertQuestionsRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertQuestionsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertQuestionsRequest.displayName = 'proto.manabie.bob.UpsertQuestionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertQuestionsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertQuestionsResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertQuestionsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertQuestionsResponse.displayName = 'proto.manabie.bob.UpsertQuestionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PresetStudyPlan = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.PresetStudyPlan, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PresetStudyPlan.displayName = 'proto.manabie.bob.PresetStudyPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertPresetStudyPlansRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertPresetStudyPlansRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertPresetStudyPlansRequest.displayName = 'proto.manabie.bob.UpsertPresetStudyPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertPresetStudyPlansResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertPresetStudyPlansResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertPresetStudyPlansResponse.displayName = 'proto.manabie.bob.UpsertPresetStudyPlansResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PresetStudyPlanWeekly = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.PresetStudyPlanWeekly, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PresetStudyPlanWeekly.displayName = 'proto.manabie.bob.PresetStudyPlanWeekly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.displayName = 'proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.displayName = 'proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertQuizRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.UpsertQuizRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.UpsertQuizRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertQuizRequest.displayName = 'proto.manabie.bob.UpsertQuizRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.UpsertQuizResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.UpsertQuizResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.UpsertQuizResponse.displayName = 'proto.manabie.bob.UpsertQuizResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.LocalGrade = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.LocalGrade, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.LocalGrade.displayName = 'proto.manabie.bob.LocalGrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveGradeMapResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveGradeMapResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveGradeMapResponse.displayName = 'proto.manabie.bob.RetrieveGradeMapResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveGradeMapRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveGradeMapRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveGradeMapRequest.displayName = 'proto.manabie.bob.RetrieveGradeMapRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetHistoryQuizDetailRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetHistoryQuizDetailRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetHistoryQuizDetailRequest.displayName = 'proto.manabie.bob.GetHistoryQuizDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetHistoryQuizDetailResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetHistoryQuizDetailResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetHistoryQuizDetailResponse.displayName = 'proto.manabie.bob.GetHistoryQuizDetailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.SuggestLORequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.SuggestLORequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.SuggestLORequest.displayName = 'proto.manabie.bob.SuggestLORequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.SuggestLOResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.SuggestLOResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.SuggestLOResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.SuggestLOResponse.displayName = 'proto.manabie.bob.SuggestLOResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PublishTopicsRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.PublishTopicsRequest.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.PublishTopicsRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PublishTopicsRequest.displayName = 'proto.manabie.bob.PublishTopicsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.PublishTopicsResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.PublishTopicsResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.PublishTopicsResponse.displayName = 'proto.manabie.bob.PublishTopicsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.Chapter = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.Chapter.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.Chapter, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.Chapter.displayName = 'proto.manabie.bob.Chapter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetChapterListRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.GetChapterListRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetChapterListRequest.displayName = 'proto.manabie.bob.GetChapterListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.GetChapterListResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.GetChapterListResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.GetChapterListResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.GetChapterListResponse.displayName = 'proto.manabie.bob.GetChapterListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCoursesRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.manabie.bob.RetrieveCoursesRequest, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCoursesRequest.displayName = 'proto.manabie.bob.RetrieveCoursesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCoursesResponse = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveCoursesResponse.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveCoursesResponse, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCoursesResponse.displayName = 'proto.manabie.bob.RetrieveCoursesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.manabie.bob.RetrieveCoursesResponse.Course = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.manabie.bob.RetrieveCoursesResponse.Course.repeatedFields_, null);
};

goog.inherits(proto.manabie.bob.RetrieveCoursesResponse.Course, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.manabie.bob.RetrieveCoursesResponse.Course.displayName = 'proto.manabie.bob.RetrieveCoursesResponse.Course';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListTopicRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListTopicRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListTopicRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListTopicRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      country: jspb.Message.getFieldWithDefault(msg, 1, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 2, ""),
      subject: jspb.Message.getFieldWithDefault(msg, 3, 0),
      topicType: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListTopicRequest}
 */


proto.manabie.bob.ListTopicRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListTopicRequest();
  return proto.manabie.bob.ListTopicRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListTopicRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListTopicRequest}
 */


proto.manabie.bob.ListTopicRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.TopicType} */
        reader.readEnum();
        msg.setTopicType(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListTopicRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListTopicRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListTopicRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListTopicRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getTopicType();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }
};
/**
 * optional Country country = 1;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.ListTopicRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.ListTopicRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string grade = 2;
 * @return {string}
 */


proto.manabie.bob.ListTopicRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.ListTopicRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Subject subject = 3;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.ListTopicRequest.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.ListTopicRequest.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional TopicType topic_type = 4;
 * @return {!proto.manabie.bob.TopicType}
 */


proto.manabie.bob.ListTopicRequest.prototype.getTopicType = function () {
  return (
    /** @type {!proto.manabie.bob.TopicType} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.TopicType} value */


proto.manabie.bob.ListTopicRequest.prototype.setTopicType = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.ListTopicResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListTopicResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListTopicResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListTopicResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListTopicResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.Topic.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListTopicResponse}
 */


proto.manabie.bob.ListTopicResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListTopicResponse();
  return proto.manabie.bob.ListTopicResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListTopicResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListTopicResponse}
 */


proto.manabie.bob.ListTopicResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Topic();
        reader.readMessage(value, proto.manabie.bob.Topic.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListTopicResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListTopicResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListTopicResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListTopicResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Topic.serializeBinaryToWriter);
  }
};
/**
 * repeated Topic topics = 1;
 * @return {!Array<!proto.manabie.bob.Topic>}
 */


proto.manabie.bob.ListTopicResponse.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Topic>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Topic, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Topic>} value */


proto.manabie.bob.ListTopicResponse.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Topic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.ListTopicResponse.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Topic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.ListTopicResponse.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListTopicsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListTopicsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListTopicsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListTopicsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      country: jspb.Message.getFieldWithDefault(msg, 1, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 2, ""),
      subject: jspb.Message.getFieldWithDefault(msg, 3, 0),
      topicType: jspb.Message.getFieldWithDefault(msg, 4, 0),
      withCompleteness: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListTopicsRequest}
 */


proto.manabie.bob.ListTopicsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListTopicsRequest();
  return proto.manabie.bob.ListTopicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListTopicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListTopicsRequest}
 */


proto.manabie.bob.ListTopicsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.TopicType} */
        reader.readEnum();
        msg.setTopicType(value);
        break;

      case 5:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setWithCompleteness(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListTopicsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListTopicsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListTopicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListTopicsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(1, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getTopicType();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }

  f = message.getWithCompleteness();

  if (f) {
    writer.writeBool(5, f);
  }
};
/**
 * optional Country country = 1;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.ListTopicsRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.ListTopicsRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string grade = 2;
 * @return {string}
 */


proto.manabie.bob.ListTopicsRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.ListTopicsRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Subject subject = 3;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.ListTopicsRequest.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.ListTopicsRequest.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional TopicType topic_type = 4;
 * @return {!proto.manabie.bob.TopicType}
 */


proto.manabie.bob.ListTopicsRequest.prototype.getTopicType = function () {
  return (
    /** @type {!proto.manabie.bob.TopicType} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.TopicType} value */


proto.manabie.bob.ListTopicsRequest.prototype.setTopicType = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional bool with_completeness = 5;
 * @return {boolean}
 */


proto.manabie.bob.ListTopicsRequest.prototype.getWithCompleteness = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 5, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.ListTopicsRequest.prototype.setWithCompleteness = function (value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.ListTopicsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListTopicsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListTopicsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListTopicsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListTopicsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.ListTopicsResponse.Data.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListTopicsResponse}
 */


proto.manabie.bob.ListTopicsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListTopicsResponse();
  return proto.manabie.bob.ListTopicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListTopicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListTopicsResponse}
 */


proto.manabie.bob.ListTopicsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.ListTopicsResponse.Data();
        reader.readMessage(value, proto.manabie.bob.ListTopicsResponse.Data.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListTopicsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListTopicsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListTopicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListTopicsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.ListTopicsResponse.Data.serializeBinaryToWriter);
  }
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.ListTopicsResponse.Data.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.ListTopicsResponse.Data.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.ListTopicsResponse.Data} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.ListTopicsResponse.Data.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topic: (f = msg.getTopic()) && proto.manabie.bob.Topic.toObject(includeInstance, f),
      totalFinishedLos: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.ListTopicsResponse.Data}
 */


proto.manabie.bob.ListTopicsResponse.Data.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.ListTopicsResponse.Data();
  return proto.manabie.bob.ListTopicsResponse.Data.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.ListTopicsResponse.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.ListTopicsResponse.Data}
 */


proto.manabie.bob.ListTopicsResponse.Data.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Topic();
        reader.readMessage(value, proto.manabie.bob.Topic.deserializeBinaryFromReader);
        msg.setTopic(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalFinishedLos(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.ListTopicsResponse.Data.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.ListTopicsResponse.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.ListTopicsResponse.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.ListTopicsResponse.Data.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopic();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.Topic.serializeBinaryToWriter);
  }

  f = message.getTotalFinishedLos();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * optional Topic topic = 1;
 * @return {?proto.manabie.bob.Topic}
 */


proto.manabie.bob.ListTopicsResponse.Data.prototype.getTopic = function () {
  return (
    /** @type{?proto.manabie.bob.Topic} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.Topic, 1)
  );
};
/** @param {?proto.manabie.bob.Topic|undefined} value */


proto.manabie.bob.ListTopicsResponse.Data.prototype.setTopic = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.ListTopicsResponse.Data.prototype.clearTopic = function () {
  this.setTopic(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.ListTopicsResponse.Data.prototype.hasTopic = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional int32 total_finished_los = 2;
 * @return {number}
 */


proto.manabie.bob.ListTopicsResponse.Data.prototype.getTotalFinishedLos = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.ListTopicsResponse.Data.prototype.setTotalFinishedLos = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * repeated Data topics = 1;
 * @return {!Array<!proto.manabie.bob.ListTopicsResponse.Data>}
 */


proto.manabie.bob.ListTopicsResponse.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.ListTopicsResponse.Data>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.ListTopicsResponse.Data, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.ListTopicsResponse.Data>} value */


proto.manabie.bob.ListTopicsResponse.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.ListTopicsResponse.Data=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.ListTopicsResponse.Data}
 */


proto.manabie.bob.ListTopicsResponse.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.ListTopicsResponse.Data, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.ListTopicsResponse.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Topic.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Topic.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Topic} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Topic.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 4, ""),
      subject: jspb.Message.getFieldWithDefault(msg, 5, 0),
      type: jspb.Message.getFieldWithDefault(msg, 6, 0),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      status: jspb.Message.getFieldWithDefault(msg, 9, 0),
      displayOrder: jspb.Message.getFieldWithDefault(msg, 10, 0),
      publishedAt: (f = msg.getPublishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      totalLos: jspb.Message.getFieldWithDefault(msg, 12, 0),
      chapterId: jspb.Message.getFieldWithDefault(msg, 13, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.Topic.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Topic();
  return proto.manabie.bob.Topic.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Topic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.Topic.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 5:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 6:
        var value =
        /** @type {!proto.manabie.bob.TopicType} */
        reader.readEnum();
        msg.setType(value);
        break;

      case 7:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 9:
        var value =
        /** @type {!proto.manabie.bob.TopicStatus} */
        reader.readEnum();
        msg.setStatus(value);
        break;

      case 10:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDisplayOrder(value);
        break;

      case 11:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setPublishedAt(value);
        break;

      case 12:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalLos(value);
        break;

      case 13:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChapterId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Topic.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Topic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Topic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Topic.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(5, f);
  }

  f = message.getType();

  if (f !== 0.0) {
    writer.writeEnum(6, f);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(7, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getStatus();

  if (f !== 0.0) {
    writer.writeEnum(9, f);
  }

  f = message.getDisplayOrder();

  if (f !== 0) {
    writer.writeInt32(10, f);
  }

  f = message.getPublishedAt();

  if (f != null) {
    writer.writeMessage(11, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getTotalLos();

  if (f !== 0) {
    writer.writeInt32(12, f);
  }

  f = message.getChapterId();

  if (f.length > 0) {
    writer.writeString(13, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.Topic.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Topic.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.Topic.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Topic.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.Topic.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.Topic.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string grade = 4;
 * @return {string}
 */


proto.manabie.bob.Topic.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Topic.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional Subject subject = 5;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.Topic.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.Topic.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional TopicType type = 6;
 * @return {!proto.manabie.bob.TopicType}
 */


proto.manabie.bob.Topic.prototype.getType = function () {
  return (
    /** @type {!proto.manabie.bob.TopicType} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {!proto.manabie.bob.TopicType} value */


proto.manabie.bob.Topic.prototype.setType = function (value) {
  jspb.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Topic.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Topic.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Topic.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Topic.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 7) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Topic.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Topic.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Topic.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Topic.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * optional TopicStatus status = 9;
 * @return {!proto.manabie.bob.TopicStatus}
 */


proto.manabie.bob.Topic.prototype.getStatus = function () {
  return (
    /** @type {!proto.manabie.bob.TopicStatus} */
    jspb.Message.getFieldWithDefault(this, 9, 0)
  );
};
/** @param {!proto.manabie.bob.TopicStatus} value */


proto.manabie.bob.Topic.prototype.setStatus = function (value) {
  jspb.Message.setProto3EnumField(this, 9, value);
};
/**
 * optional int32 display_order = 10;
 * @return {number}
 */


proto.manabie.bob.Topic.prototype.getDisplayOrder = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 10, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Topic.prototype.setDisplayOrder = function (value) {
  jspb.Message.setProto3IntField(this, 10, value);
};
/**
 * optional google.protobuf.Timestamp published_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Topic.prototype.getPublishedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Topic.prototype.setPublishedAt = function (value) {
  jspb.Message.setWrapperField(this, 11, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Topic.prototype.clearPublishedAt = function () {
  this.setPublishedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Topic.prototype.hasPublishedAt = function () {
  return jspb.Message.getField(this, 11) != null;
};
/**
 * optional int32 total_los = 12;
 * @return {number}
 */


proto.manabie.bob.Topic.prototype.getTotalLos = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 12, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Topic.prototype.setTotalLos = function (value) {
  jspb.Message.setProto3IntField(this, 12, value);
};
/**
 * optional string chapter_id = 13;
 * @return {string}
 */


proto.manabie.bob.Topic.prototype.getChapterId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 13, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Topic.prototype.setChapterId = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveLORequest.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveLORequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveLORequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveLORequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveLORequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      topicIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      withCompleteness: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveLORequest}
 */


proto.manabie.bob.RetrieveLORequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveLORequest();
  return proto.manabie.bob.RetrieveLORequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveLORequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveLORequest}
 */


proto.manabie.bob.RetrieveLORequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addTopicIds(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setWithCompleteness(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveLORequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveLORequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveLORequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveLORequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getTopicIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(2, f);
  }

  f = message.getWithCompleteness();

  if (f) {
    writer.writeBool(3, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveLORequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveLORequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated string topic_ids = 2;
 * @return {!Array<string>}
 */


proto.manabie.bob.RetrieveLORequest.prototype.getTopicIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 2)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.RetrieveLORequest.prototype.setTopicIdsList = function (value) {
  jspb.Message.setField(this, 2, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.RetrieveLORequest.prototype.addTopicIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveLORequest.prototype.clearTopicIdsList = function () {
  this.setTopicIdsList([]);
};
/**
 * optional bool with_completeness = 3;
 * @return {boolean}
 */


proto.manabie.bob.RetrieveLORequest.prototype.getWithCompleteness = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.RetrieveLORequest.prototype.setWithCompleteness = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Completenes.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Completenes.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Completenes} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Completenes.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      quizFinished: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
      videoFinished: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
      studyGuideFinished: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
      firstQuizCorrectness: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Completenes}
 */


proto.manabie.bob.Completenes.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Completenes();
  return proto.manabie.bob.Completenes.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Completenes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Completenes}
 */


proto.manabie.bob.Completenes.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setQuizFinished(value);
        break;

      case 2:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setVideoFinished(value);
        break;

      case 3:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setStudyGuideFinished(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readFloat();
        msg.setFirstQuizCorrectness(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Completenes.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Completenes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Completenes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Completenes.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuizFinished();

  if (f) {
    writer.writeBool(1, f);
  }

  f = message.getVideoFinished();

  if (f) {
    writer.writeBool(2, f);
  }

  f = message.getStudyGuideFinished();

  if (f) {
    writer.writeBool(3, f);
  }

  f = message.getFirstQuizCorrectness();

  if (f !== 0.0) {
    writer.writeFloat(4, f);
  }
};
/**
 * optional bool quiz_finished = 1;
 * @return {boolean}
 */


proto.manabie.bob.Completenes.prototype.getQuizFinished = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Completenes.prototype.setQuizFinished = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional bool video_finished = 2;
 * @return {boolean}
 */


proto.manabie.bob.Completenes.prototype.getVideoFinished = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 2, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Completenes.prototype.setVideoFinished = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool study_guide_finished = 3;
 * @return {boolean}
 */


proto.manabie.bob.Completenes.prototype.getStudyGuideFinished = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 3, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Completenes.prototype.setStudyGuideFinished = function (value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};
/**
 * optional float first_quiz_correctness = 4;
 * @return {number}
 */


proto.manabie.bob.Completenes.prototype.getFirstQuizCorrectness = function () {
  return (
    /** @type {number} */
    jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0)
  );
};
/** @param {number} value */


proto.manabie.bob.Completenes.prototype.setFirstQuizCorrectness = function (value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveLOResponse.repeatedFields_ = [1, 2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveLOResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveLOResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveLOResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveLOResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      learningObjectivesList: jspb.Message.toObjectList(msg.getLearningObjectivesList(), proto.manabie.bob.LearningObjective.toObject, includeInstance),
      completenessesList: jspb.Message.toObjectList(msg.getCompletenessesList(), proto.manabie.bob.Completenes.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveLOResponse}
 */


proto.manabie.bob.RetrieveLOResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveLOResponse();
  return proto.manabie.bob.RetrieveLOResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveLOResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveLOResponse}
 */


proto.manabie.bob.RetrieveLOResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.LearningObjective();
        reader.readMessage(value, proto.manabie.bob.LearningObjective.deserializeBinaryFromReader);
        msg.addLearningObjectives(value);
        break;

      case 2:
        var value = new proto.manabie.bob.Completenes();
        reader.readMessage(value, proto.manabie.bob.Completenes.deserializeBinaryFromReader);
        msg.addCompletenesses(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveLOResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveLOResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveLOResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveLOResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLearningObjectivesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.LearningObjective.serializeBinaryToWriter);
  }

  f = message.getCompletenessesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.manabie.bob.Completenes.serializeBinaryToWriter);
  }
};
/**
 * repeated LearningObjective learning_objectives = 1;
 * @return {!Array<!proto.manabie.bob.LearningObjective>}
 */


proto.manabie.bob.RetrieveLOResponse.prototype.getLearningObjectivesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.LearningObjective>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.LearningObjective, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.LearningObjective>} value */


proto.manabie.bob.RetrieveLOResponse.prototype.setLearningObjectivesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.LearningObjective=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.LearningObjective}
 */


proto.manabie.bob.RetrieveLOResponse.prototype.addLearningObjectives = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.LearningObjective, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveLOResponse.prototype.clearLearningObjectivesList = function () {
  this.setLearningObjectivesList([]);
};
/**
 * repeated Completenes completenesses = 2;
 * @return {!Array<!proto.manabie.bob.Completenes>}
 */


proto.manabie.bob.RetrieveLOResponse.prototype.getCompletenessesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Completenes>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Completenes, 2)
  );
};
/** @param {!Array<!proto.manabie.bob.Completenes>} value */


proto.manabie.bob.RetrieveLOResponse.prototype.setCompletenessesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.manabie.bob.Completenes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Completenes}
 */


proto.manabie.bob.RetrieveLOResponse.prototype.addCompletenesses = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.manabie.bob.Completenes, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveLOResponse.prototype.clearCompletenessesList = function () {
  this.setCompletenessesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Question.repeatedFields_ = [5, 10, 12, 15, 16];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Question.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Question.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Question} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Question.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      masterQuestionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      question: jspb.Message.getFieldWithDefault(msg, 4, ""),
      answersList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
      explanation: jspb.Message.getFieldWithDefault(msg, 6, ""),
      difficultyLevel: jspb.Message.getFieldWithDefault(msg, 7, 0),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      questionsTagLoList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
      questionRendered: jspb.Message.getFieldWithDefault(msg, 11, ""),
      answersRenderedList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
      explanationRendered: jspb.Message.getFieldWithDefault(msg, 13, ""),
      isWaitingForRender: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
      explanationWrongAnswerList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
      explanationWrongAnswerRenderedList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Question}
 */


proto.manabie.bob.Question.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Question();
  return proto.manabie.bob.Question.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Question} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Question}
 */


proto.manabie.bob.Question.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMasterQuestionId(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setQuestion(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addAnswers(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setExplanation(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDifficultyLevel(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 9:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 10:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addQuestionsTagLo(value);
        break;

      case 11:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setQuestionRendered(value);
        break;

      case 12:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addAnswersRendered(value);
        break;

      case 13:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setExplanationRendered(value);
        break;

      case 14:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setIsWaitingForRender(value);
        break;

      case 15:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addExplanationWrongAnswer(value);
        break;

      case 16:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addExplanationWrongAnswerRendered(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Question.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Question.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Question} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Question.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getMasterQuestionId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getQuestion();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getAnswersList();

  if (f.length > 0) {
    writer.writeRepeatedString(5, f);
  }

  f = message.getExplanation();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getDifficultyLevel();

  if (f !== 0) {
    writer.writeInt32(7, f);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(9, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getQuestionsTagLoList();

  if (f.length > 0) {
    writer.writeRepeatedString(10, f);
  }

  f = message.getQuestionRendered();

  if (f.length > 0) {
    writer.writeString(11, f);
  }

  f = message.getAnswersRenderedList();

  if (f.length > 0) {
    writer.writeRepeatedString(12, f);
  }

  f = message.getExplanationRendered();

  if (f.length > 0) {
    writer.writeString(13, f);
  }

  f = message.getIsWaitingForRender();

  if (f) {
    writer.writeBool(14, f);
  }

  f = message.getExplanationWrongAnswerList();

  if (f.length > 0) {
    writer.writeRepeatedString(15, f);
  }

  f = message.getExplanationWrongAnswerRenderedList();

  if (f.length > 0) {
    writer.writeRepeatedString(16, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.Question.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Question.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string master_question_id = 2;
 * @return {string}
 */


proto.manabie.bob.Question.prototype.getMasterQuestionId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Question.prototype.setMasterQuestionId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.Question.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.Question.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string question = 4;
 * @return {string}
 */


proto.manabie.bob.Question.prototype.getQuestion = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Question.prototype.setQuestion = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * repeated string answers = 5;
 * @return {!Array<string>}
 */


proto.manabie.bob.Question.prototype.getAnswersList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 5)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Question.prototype.setAnswersList = function (value) {
  jspb.Message.setField(this, 5, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Question.prototype.addAnswers = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Question.prototype.clearAnswersList = function () {
  this.setAnswersList([]);
};
/**
 * optional string explanation = 6;
 * @return {string}
 */


proto.manabie.bob.Question.prototype.getExplanation = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Question.prototype.setExplanation = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int32 difficulty_level = 7;
 * @return {number}
 */


proto.manabie.bob.Question.prototype.getDifficultyLevel = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Question.prototype.setDifficultyLevel = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * optional google.protobuf.Timestamp updated_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Question.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Question.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Question.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Question.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Question.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Question.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Question.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Question.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 9) != null;
};
/**
 * repeated string questions_tag_lo = 10;
 * @return {!Array<string>}
 */


proto.manabie.bob.Question.prototype.getQuestionsTagLoList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 10)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Question.prototype.setQuestionsTagLoList = function (value) {
  jspb.Message.setField(this, 10, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Question.prototype.addQuestionsTagLo = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Question.prototype.clearQuestionsTagLoList = function () {
  this.setQuestionsTagLoList([]);
};
/**
 * optional string question_rendered = 11;
 * @return {string}
 */


proto.manabie.bob.Question.prototype.getQuestionRendered = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 11, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Question.prototype.setQuestionRendered = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};
/**
 * repeated string answers_rendered = 12;
 * @return {!Array<string>}
 */


proto.manabie.bob.Question.prototype.getAnswersRenderedList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 12)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Question.prototype.setAnswersRenderedList = function (value) {
  jspb.Message.setField(this, 12, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Question.prototype.addAnswersRendered = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Question.prototype.clearAnswersRenderedList = function () {
  this.setAnswersRenderedList([]);
};
/**
 * optional string explanation_rendered = 13;
 * @return {string}
 */


proto.manabie.bob.Question.prototype.getExplanationRendered = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 13, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Question.prototype.setExplanationRendered = function (value) {
  jspb.Message.setProto3StringField(this, 13, value);
};
/**
 * optional bool is_waiting_for_render = 14;
 * @return {boolean}
 */


proto.manabie.bob.Question.prototype.getIsWaitingForRender = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 14, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.Question.prototype.setIsWaitingForRender = function (value) {
  jspb.Message.setProto3BooleanField(this, 14, value);
};
/**
 * repeated string explanation_wrong_answer = 15;
 * @return {!Array<string>}
 */


proto.manabie.bob.Question.prototype.getExplanationWrongAnswerList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 15)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Question.prototype.setExplanationWrongAnswerList = function (value) {
  jspb.Message.setField(this, 15, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Question.prototype.addExplanationWrongAnswer = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Question.prototype.clearExplanationWrongAnswerList = function () {
  this.setExplanationWrongAnswerList([]);
};
/**
 * repeated string explanation_wrong_answer_rendered = 16;
 * @return {!Array<string>}
 */


proto.manabie.bob.Question.prototype.getExplanationWrongAnswerRenderedList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 16)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.Question.prototype.setExplanationWrongAnswerRenderedList = function (value) {
  jspb.Message.setField(this, 16, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.Question.prototype.addExplanationWrongAnswerRendered = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Question.prototype.clearExplanationWrongAnswerRenderedList = function () {
  this.setExplanationWrongAnswerRenderedList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.LearningObjective.repeatedFields_ = [12];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.LearningObjective.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.LearningObjective.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.LearningObjective} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.LearningObjective.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 4, ""),
      subject: jspb.Message.getFieldWithDefault(msg, 5, 0),
      displayOrder: jspb.Message.getFieldWithDefault(msg, 6, 0),
      video: jspb.Message.getFieldWithDefault(msg, 7, ""),
      studyGuide: jspb.Message.getFieldWithDefault(msg, 8, ""),
      topicId: jspb.Message.getFieldWithDefault(msg, 9, ""),
      masterLo: jspb.Message.getFieldWithDefault(msg, 10, ""),
      videoScript: jspb.Message.getFieldWithDefault(msg, 11, ""),
      prerequisitesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.LearningObjective}
 */


proto.manabie.bob.LearningObjective.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.LearningObjective();
  return proto.manabie.bob.LearningObjective.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.LearningObjective} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.LearningObjective}
 */


proto.manabie.bob.LearningObjective.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 5:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDisplayOrder(value);
        break;

      case 7:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setVideo(value);
        break;

      case 8:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudyGuide(value);
        break;

      case 9:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTopicId(value);
        break;

      case 10:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setMasterLo(value);
        break;

      case 11:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setVideoScript(value);
        break;

      case 12:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addPrerequisites(value);
        break;

      case 13:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 14:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.LearningObjective.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.LearningObjective.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.LearningObjective} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.LearningObjective.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(5, f);
  }

  f = message.getDisplayOrder();

  if (f !== 0) {
    writer.writeInt32(6, f);
  }

  f = message.getVideo();

  if (f.length > 0) {
    writer.writeString(7, f);
  }

  f = message.getStudyGuide();

  if (f.length > 0) {
    writer.writeString(8, f);
  }

  f = message.getTopicId();

  if (f.length > 0) {
    writer.writeString(9, f);
  }

  f = message.getMasterLo();

  if (f.length > 0) {
    writer.writeString(10, f);
  }

  f = message.getVideoScript();

  if (f.length > 0) {
    writer.writeString(11, f);
  }

  f = message.getPrerequisitesList();

  if (f.length > 0) {
    writer.writeRepeatedString(12, f);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(13, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(14, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.LearningObjective.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.LearningObjective.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string grade = 4;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional Subject subject = 5;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.LearningObjective.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.LearningObjective.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional int32 display_order = 6;
 * @return {number}
 */


proto.manabie.bob.LearningObjective.prototype.getDisplayOrder = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.LearningObjective.prototype.setDisplayOrder = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional string video = 7;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getVideo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 7, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setVideo = function (value) {
  jspb.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string study_guide = 8;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getStudyGuide = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 8, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setStudyGuide = function (value) {
  jspb.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string topic_id = 9;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getTopicId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 9, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setTopicId = function (value) {
  jspb.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string master_lo = 10;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getMasterLo = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 10, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setMasterLo = function (value) {
  jspb.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string video_script = 11;
 * @return {string}
 */


proto.manabie.bob.LearningObjective.prototype.getVideoScript = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 11, "")
  );
};
/** @param {string} value */


proto.manabie.bob.LearningObjective.prototype.setVideoScript = function (value) {
  jspb.Message.setProto3StringField(this, 11, value);
};
/**
 * repeated string prerequisites = 12;
 * @return {!Array<string>}
 */


proto.manabie.bob.LearningObjective.prototype.getPrerequisitesList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 12)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.LearningObjective.prototype.setPrerequisitesList = function (value) {
  jspb.Message.setField(this, 12, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.LearningObjective.prototype.addPrerequisites = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.LearningObjective.prototype.clearPrerequisitesList = function () {
  this.setPrerequisitesList([]);
};
/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.LearningObjective.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.LearningObjective.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 13, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.LearningObjective.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.LearningObjective.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 13) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.LearningObjective.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.LearningObjective.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 14, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.LearningObjective.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.LearningObjective.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 14) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.QuizSets.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.QuizSets.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.QuizSets} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.QuizSets.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      loId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      questionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      displayOrder: jspb.Message.getFieldWithDefault(msg, 3, ""),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.QuizSets}
 */


proto.manabie.bob.QuizSets.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.QuizSets();
  return proto.manabie.bob.QuizSets.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.QuizSets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.QuizSets}
 */


proto.manabie.bob.QuizSets.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setLoId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setQuestionId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setDisplayOrder(value);
        break;

      case 4:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 5:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.QuizSets.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.QuizSets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.QuizSets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.QuizSets.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLoId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getQuestionId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getDisplayOrder();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(4, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(5, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string lo_id = 1;
 * @return {string}
 */


proto.manabie.bob.QuizSets.prototype.getLoId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.QuizSets.prototype.setLoId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string question_id = 2;
 * @return {string}
 */


proto.manabie.bob.QuizSets.prototype.getQuestionId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.QuizSets.prototype.setQuestionId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string display_order = 3;
 * @return {string}
 */


proto.manabie.bob.QuizSets.prototype.getDisplayOrder = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.QuizSets.prototype.setDisplayOrder = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional google.protobuf.Timestamp updated_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.QuizSets.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.QuizSets.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.QuizSets.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.QuizSets.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 4) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.QuizSets.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.QuizSets.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.QuizSets.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.QuizSets.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 5) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveTopicsRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveTopicsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveTopicsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveTopicsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveTopicsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveTopicsRequest}
 */


proto.manabie.bob.RetrieveTopicsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveTopicsRequest();
  return proto.manabie.bob.RetrieveTopicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveTopicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveTopicsRequest}
 */


proto.manabie.bob.RetrieveTopicsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addTopicIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveTopicsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveTopicsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveTopicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveTopicsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string topic_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.RetrieveTopicsRequest.prototype.getTopicIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.RetrieveTopicsRequest.prototype.setTopicIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.RetrieveTopicsRequest.prototype.addTopicIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveTopicsRequest.prototype.clearTopicIdsList = function () {
  this.setTopicIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveTopicsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveTopicsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveTopicsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveTopicsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveTopicsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.Topic.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveTopicsResponse}
 */


proto.manabie.bob.RetrieveTopicsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveTopicsResponse();
  return proto.manabie.bob.RetrieveTopicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveTopicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveTopicsResponse}
 */


proto.manabie.bob.RetrieveTopicsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Topic();
        reader.readMessage(value, proto.manabie.bob.Topic.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveTopicsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveTopicsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveTopicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveTopicsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Topic.serializeBinaryToWriter);
  }
};
/**
 * repeated Topic topics = 1;
 * @return {!Array<!proto.manabie.bob.Topic>}
 */


proto.manabie.bob.RetrieveTopicsResponse.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Topic>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Topic, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Topic>} value */


proto.manabie.bob.RetrieveTopicsResponse.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Topic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.RetrieveTopicsResponse.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Topic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveTopicsResponse.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertTopicsRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertTopicsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertTopicsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertTopicsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertTopicsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.Topic.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertTopicsRequest}
 */


proto.manabie.bob.UpsertTopicsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertTopicsRequest();
  return proto.manabie.bob.UpsertTopicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertTopicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertTopicsRequest}
 */


proto.manabie.bob.UpsertTopicsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Topic();
        reader.readMessage(value, proto.manabie.bob.Topic.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertTopicsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertTopicsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertTopicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertTopicsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Topic.serializeBinaryToWriter);
  }
};
/**
 * repeated Topic topics = 1;
 * @return {!Array<!proto.manabie.bob.Topic>}
 */


proto.manabie.bob.UpsertTopicsRequest.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Topic>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Topic, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Topic>} value */


proto.manabie.bob.UpsertTopicsRequest.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Topic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.UpsertTopicsRequest.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Topic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertTopicsRequest.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertTopicsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertTopicsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertTopicsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertTopicsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertTopicsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertTopicsResponse}
 */


proto.manabie.bob.UpsertTopicsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertTopicsResponse();
  return proto.manabie.bob.UpsertTopicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertTopicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertTopicsResponse}
 */


proto.manabie.bob.UpsertTopicsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addTopicIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertTopicsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertTopicsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertTopicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertTopicsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string topic_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.UpsertTopicsResponse.prototype.getTopicIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.UpsertTopicsResponse.prototype.setTopicIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.UpsertTopicsResponse.prototype.addTopicIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertTopicsResponse.prototype.clearTopicIdsList = function () {
  this.setTopicIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertLOsRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertLOsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertLOsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertLOsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertLOsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      learningObjectivesList: jspb.Message.toObjectList(msg.getLearningObjectivesList(), proto.manabie.bob.LearningObjective.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertLOsRequest}
 */


proto.manabie.bob.UpsertLOsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertLOsRequest();
  return proto.manabie.bob.UpsertLOsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertLOsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertLOsRequest}
 */


proto.manabie.bob.UpsertLOsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.LearningObjective();
        reader.readMessage(value, proto.manabie.bob.LearningObjective.deserializeBinaryFromReader);
        msg.addLearningObjectives(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertLOsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertLOsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertLOsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertLOsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLearningObjectivesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.LearningObjective.serializeBinaryToWriter);
  }
};
/**
 * repeated LearningObjective learning_objectives = 1;
 * @return {!Array<!proto.manabie.bob.LearningObjective>}
 */


proto.manabie.bob.UpsertLOsRequest.prototype.getLearningObjectivesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.LearningObjective>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.LearningObjective, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.LearningObjective>} value */


proto.manabie.bob.UpsertLOsRequest.prototype.setLearningObjectivesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.LearningObjective=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.LearningObjective}
 */


proto.manabie.bob.UpsertLOsRequest.prototype.addLearningObjectives = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.LearningObjective, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertLOsRequest.prototype.clearLearningObjectivesList = function () {
  this.setLearningObjectivesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertLOsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertLOsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertLOsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertLOsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertLOsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      loIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertLOsResponse}
 */


proto.manabie.bob.UpsertLOsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertLOsResponse();
  return proto.manabie.bob.UpsertLOsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertLOsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertLOsResponse}
 */


proto.manabie.bob.UpsertLOsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addLoIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertLOsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertLOsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertLOsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertLOsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLoIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string lo_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.UpsertLOsResponse.prototype.getLoIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.UpsertLOsResponse.prototype.setLoIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.UpsertLOsResponse.prototype.addLoIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertLOsResponse.prototype.clearLoIdsList = function () {
  this.setLoIdsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.SubmissionResult.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.SubmissionResult.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.SubmissionResult} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.SubmissionResult.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      correct: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.SubmissionResult}
 */


proto.manabie.bob.SubmissionResult.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.SubmissionResult();
  return proto.manabie.bob.SubmissionResult.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.SubmissionResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.SubmissionResult}
 */


proto.manabie.bob.SubmissionResult.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setQuestionId(value);
        break;

      case 2:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setCorrect(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.SubmissionResult.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.SubmissionResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.SubmissionResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.SubmissionResult.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuestionId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getCorrect();

  if (f) {
    writer.writeBool(2, f);
  }
};
/**
 * optional string question_id = 1;
 * @return {string}
 */


proto.manabie.bob.SubmissionResult.prototype.getQuestionId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.SubmissionResult.prototype.setQuestionId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool correct = 2;
 * @return {boolean}
 */


proto.manabie.bob.SubmissionResult.prototype.getCorrect = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 2, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.SubmissionResult.prototype.setCorrect = function (value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveSubmissionHistoryRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveSubmissionHistoryRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveSubmissionHistoryRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveSubmissionHistoryRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      loIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveSubmissionHistoryRequest}
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveSubmissionHistoryRequest();
  return proto.manabie.bob.RetrieveSubmissionHistoryRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveSubmissionHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveSubmissionHistoryRequest}
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addLoIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveSubmissionHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveSubmissionHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLoIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string lo_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.prototype.getLoIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.prototype.setLoIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.prototype.addLoIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveSubmissionHistoryRequest.prototype.clearLoIdsList = function () {
  this.setLoIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.SubmissionHistory.repeatedFields_ = [2];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.SubmissionHistory.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.SubmissionHistory.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.SubmissionHistory} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.SubmissionHistory.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      loId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      resultsList: jspb.Message.toObjectList(msg.getResultsList(), proto.manabie.bob.SubmissionResult.toObject, includeInstance),
      totalQuestion: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.SubmissionHistory}
 */


proto.manabie.bob.SubmissionHistory.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.SubmissionHistory();
  return proto.manabie.bob.SubmissionHistory.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.SubmissionHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.SubmissionHistory}
 */


proto.manabie.bob.SubmissionHistory.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setLoId(value);
        break;

      case 2:
        var value = new proto.manabie.bob.SubmissionResult();
        reader.readMessage(value, proto.manabie.bob.SubmissionResult.deserializeBinaryFromReader);
        msg.addResults(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotalQuestion(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.SubmissionHistory.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.SubmissionHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.SubmissionHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.SubmissionHistory.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLoId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getResultsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(2, f, proto.manabie.bob.SubmissionResult.serializeBinaryToWriter);
  }

  f = message.getTotalQuestion();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};
/**
 * optional string lo_id = 1;
 * @return {string}
 */


proto.manabie.bob.SubmissionHistory.prototype.getLoId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.SubmissionHistory.prototype.setLoId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated SubmissionResult results = 2;
 * @return {!Array<!proto.manabie.bob.SubmissionResult>}
 */


proto.manabie.bob.SubmissionHistory.prototype.getResultsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.SubmissionResult>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.SubmissionResult, 2)
  );
};
/** @param {!Array<!proto.manabie.bob.SubmissionResult>} value */


proto.manabie.bob.SubmissionHistory.prototype.setResultsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.manabie.bob.SubmissionResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.SubmissionResult}
 */


proto.manabie.bob.SubmissionHistory.prototype.addResults = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.manabie.bob.SubmissionResult, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.SubmissionHistory.prototype.clearResultsList = function () {
  this.setResultsList([]);
};
/**
 * optional int32 total_question = 3;
 * @return {number}
 */


proto.manabie.bob.SubmissionHistory.prototype.getTotalQuestion = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.SubmissionHistory.prototype.setTotalQuestion = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveSubmissionHistoryResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveSubmissionHistoryResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveSubmissionHistoryResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveSubmissionHistoryResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      submissionsList: jspb.Message.toObjectList(msg.getSubmissionsList(), proto.manabie.bob.SubmissionHistory.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveSubmissionHistoryResponse}
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveSubmissionHistoryResponse();
  return proto.manabie.bob.RetrieveSubmissionHistoryResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveSubmissionHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveSubmissionHistoryResponse}
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.SubmissionHistory();
        reader.readMessage(value, proto.manabie.bob.SubmissionHistory.deserializeBinaryFromReader);
        msg.addSubmissions(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveSubmissionHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveSubmissionHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSubmissionsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.SubmissionHistory.serializeBinaryToWriter);
  }
};
/**
 * repeated SubmissionHistory submissions = 1;
 * @return {!Array<!proto.manabie.bob.SubmissionHistory>}
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.prototype.getSubmissionsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.SubmissionHistory>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.SubmissionHistory, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.SubmissionHistory>} value */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.prototype.setSubmissionsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.SubmissionHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.SubmissionHistory}
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.prototype.addSubmissions = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.SubmissionHistory, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveSubmissionHistoryResponse.prototype.clearSubmissionsList = function () {
  this.setSubmissionsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.TakeTheQuizRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.TakeTheQuizRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.TakeTheQuizRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.TakeTheQuizRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      loId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
      page: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.TakeTheQuizRequest}
 */


proto.manabie.bob.TakeTheQuizRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.TakeTheQuizRequest();
  return proto.manabie.bob.TakeTheQuizRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.TakeTheQuizRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.TakeTheQuizRequest}
 */


proto.manabie.bob.TakeTheQuizRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setLoId(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setLimit(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPage(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.TakeTheQuizRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.TakeTheQuizRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.TakeTheQuizRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.TakeTheQuizRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLoId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getLimit();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getPage();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};
/**
 * optional string lo_id = 1;
 * @return {string}
 */


proto.manabie.bob.TakeTheQuizRequest.prototype.getLoId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.TakeTheQuizRequest.prototype.setLoId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 limit = 2;
 * @return {number}
 */


proto.manabie.bob.TakeTheQuizRequest.prototype.getLimit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.TakeTheQuizRequest.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 page = 3;
 * @return {number}
 */


proto.manabie.bob.TakeTheQuizRequest.prototype.getPage = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.TakeTheQuizRequest.prototype.setPage = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.TakeTheQuizResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.TakeTheQuizResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.TakeTheQuizResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.TakeTheQuizResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.TakeTheQuizResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      quizsetList: jspb.Message.toObjectList(msg.getQuizsetList(), proto.manabie.bob.Question.toObject, includeInstance),
      total: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.TakeTheQuizResponse}
 */


proto.manabie.bob.TakeTheQuizResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.TakeTheQuizResponse();
  return proto.manabie.bob.TakeTheQuizResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.TakeTheQuizResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.TakeTheQuizResponse}
 */


proto.manabie.bob.TakeTheQuizResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Question();
        reader.readMessage(value, proto.manabie.bob.Question.deserializeBinaryFromReader);
        msg.addQuizset(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotal(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.TakeTheQuizResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.TakeTheQuizResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.TakeTheQuizResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.TakeTheQuizResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuizsetList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Question.serializeBinaryToWriter);
  }

  f = message.getTotal();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * repeated Question quizset = 1;
 * @return {!Array<!proto.manabie.bob.Question>}
 */


proto.manabie.bob.TakeTheQuizResponse.prototype.getQuizsetList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Question>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Question, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Question>} value */


proto.manabie.bob.TakeTheQuizResponse.prototype.setQuizsetList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Question=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Question}
 */


proto.manabie.bob.TakeTheQuizResponse.prototype.addQuizset = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Question, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.TakeTheQuizResponse.prototype.clearQuizsetList = function () {
  this.setQuizsetList([]);
};
/**
 * optional int32 total = 2;
 * @return {number}
 */


proto.manabie.bob.TakeTheQuizResponse.prototype.getTotal = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.TakeTheQuizResponse.prototype.setTotal = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertQuestionsRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertQuestionsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertQuestionsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertQuestionsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertQuestionsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      questionsList: jspb.Message.toObjectList(msg.getQuestionsList(), proto.manabie.bob.Question.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertQuestionsRequest}
 */


proto.manabie.bob.UpsertQuestionsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertQuestionsRequest();
  return proto.manabie.bob.UpsertQuestionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertQuestionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertQuestionsRequest}
 */


proto.manabie.bob.UpsertQuestionsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Question();
        reader.readMessage(value, proto.manabie.bob.Question.deserializeBinaryFromReader);
        msg.addQuestions(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertQuestionsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertQuestionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertQuestionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertQuestionsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuestionsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Question.serializeBinaryToWriter);
  }
};
/**
 * repeated Question questions = 1;
 * @return {!Array<!proto.manabie.bob.Question>}
 */


proto.manabie.bob.UpsertQuestionsRequest.prototype.getQuestionsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Question>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Question, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Question>} value */


proto.manabie.bob.UpsertQuestionsRequest.prototype.setQuestionsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Question=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Question}
 */


proto.manabie.bob.UpsertQuestionsRequest.prototype.addQuestions = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Question, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertQuestionsRequest.prototype.clearQuestionsList = function () {
  this.setQuestionsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertQuestionsResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertQuestionsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertQuestionsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertQuestionsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertQuestionsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      questionIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertQuestionsResponse}
 */


proto.manabie.bob.UpsertQuestionsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertQuestionsResponse();
  return proto.manabie.bob.UpsertQuestionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertQuestionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertQuestionsResponse}
 */


proto.manabie.bob.UpsertQuestionsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addQuestionIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertQuestionsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertQuestionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertQuestionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertQuestionsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuestionIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string question_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.UpsertQuestionsResponse.prototype.getQuestionIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.UpsertQuestionsResponse.prototype.setQuestionIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.UpsertQuestionsResponse.prototype.addQuestionIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertQuestionsResponse.prototype.clearQuestionIdsList = function () {
  this.setQuestionIdsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PresetStudyPlan.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PresetStudyPlan.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PresetStudyPlan} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PresetStudyPlan.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 4, ""),
      subject: jspb.Message.getFieldWithDefault(msg, 5, 0),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PresetStudyPlan}
 */


proto.manabie.bob.PresetStudyPlan.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PresetStudyPlan();
  return proto.manabie.bob.PresetStudyPlan.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PresetStudyPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PresetStudyPlan}
 */


proto.manabie.bob.PresetStudyPlan.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 5:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 6:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      case 7:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setStartDate(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PresetStudyPlan.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PresetStudyPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PresetStudyPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PresetStudyPlan.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(4, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(5, f);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(6, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(7, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getStartDate();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PresetStudyPlan.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PresetStudyPlan.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.PresetStudyPlan.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string grade = 4;
 * @return {string}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 4, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PresetStudyPlan.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional Subject subject = 5;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.PresetStudyPlan.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.PresetStudyPlan.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.PresetStudyPlan.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.PresetStudyPlan.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 6) != null;
};
/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.PresetStudyPlan.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.PresetStudyPlan.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.PresetStudyPlan.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 7) != null;
};
/**
 * optional google.protobuf.Timestamp start_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.PresetStudyPlan.prototype.getStartDate = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.PresetStudyPlan.prototype.setStartDate = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.PresetStudyPlan.prototype.clearStartDate = function () {
  this.setStartDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.PresetStudyPlan.prototype.hasStartDate = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertPresetStudyPlansRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertPresetStudyPlansRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertPresetStudyPlansRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertPresetStudyPlansRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlansList: jspb.Message.toObjectList(msg.getPresetStudyPlansList(), proto.manabie.bob.PresetStudyPlan.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlansRequest}
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertPresetStudyPlansRequest();
  return proto.manabie.bob.UpsertPresetStudyPlansRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlansRequest}
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.PresetStudyPlan();
        reader.readMessage(value, proto.manabie.bob.PresetStudyPlan.deserializeBinaryFromReader);
        msg.addPresetStudyPlans(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertPresetStudyPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlansList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.PresetStudyPlan.serializeBinaryToWriter);
  }
};
/**
 * repeated PresetStudyPlan preset_study_plans = 1;
 * @return {!Array<!proto.manabie.bob.PresetStudyPlan>}
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.prototype.getPresetStudyPlansList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PresetStudyPlan>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.PresetStudyPlan, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.PresetStudyPlan>} value */


proto.manabie.bob.UpsertPresetStudyPlansRequest.prototype.setPresetStudyPlansList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.PresetStudyPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PresetStudyPlan}
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.prototype.addPresetStudyPlans = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.PresetStudyPlan, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertPresetStudyPlansRequest.prototype.clearPresetStudyPlansList = function () {
  this.setPresetStudyPlansList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertPresetStudyPlansResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertPresetStudyPlansResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertPresetStudyPlansResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertPresetStudyPlansResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlanIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlansResponse}
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertPresetStudyPlansResponse();
  return proto.manabie.bob.UpsertPresetStudyPlansResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlansResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlansResponse}
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addPresetStudyPlanIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertPresetStudyPlansResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlansResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlanIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string preset_study_plan_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.prototype.getPresetStudyPlanIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.UpsertPresetStudyPlansResponse.prototype.setPresetStudyPlanIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.prototype.addPresetStudyPlanIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertPresetStudyPlansResponse.prototype.clearPresetStudyPlanIdsList = function () {
  this.setPresetStudyPlanIdsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PresetStudyPlanWeekly.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PresetStudyPlanWeekly.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PresetStudyPlanWeekly} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PresetStudyPlanWeekly.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      topicId: jspb.Message.getFieldWithDefault(msg, 2, ""),
      presetStudyPlanId: jspb.Message.getFieldWithDefault(msg, 3, ""),
      week: jspb.Message.getFieldWithDefault(msg, 4, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PresetStudyPlanWeekly}
 */


proto.manabie.bob.PresetStudyPlanWeekly.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PresetStudyPlanWeekly();
  return proto.manabie.bob.PresetStudyPlanWeekly.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PresetStudyPlanWeekly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PresetStudyPlanWeekly}
 */


proto.manabie.bob.PresetStudyPlanWeekly.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setTopicId(value);
        break;

      case 3:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setPresetStudyPlanId(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setWeek(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PresetStudyPlanWeekly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PresetStudyPlanWeekly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PresetStudyPlanWeekly.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getTopicId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getPresetStudyPlanId();

  if (f.length > 0) {
    writer.writeString(3, f);
  }

  f = message.getWeek();

  if (f !== 0) {
    writer.writeInt32(4, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string topic_id = 2;
 * @return {string}
 */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.getTopicId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.setTopicId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string preset_study_plan_id = 3;
 * @return {string}
 */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.getPresetStudyPlanId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 3, "")
  );
};
/** @param {string} value */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.setPresetStudyPlanId = function (value) {
  jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 week = 4;
 * @return {number}
 */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.getWeek = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.PresetStudyPlanWeekly.prototype.setWeek = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlanWeekliesList: jspb.Message.toObjectList(msg.getPresetStudyPlanWeekliesList(), proto.manabie.bob.PresetStudyPlanWeekly.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest();
  return proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.PresetStudyPlanWeekly();
        reader.readMessage(value, proto.manabie.bob.PresetStudyPlanWeekly.deserializeBinaryFromReader);
        msg.addPresetStudyPlanWeeklies(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlanWeekliesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.PresetStudyPlanWeekly.serializeBinaryToWriter);
  }
};
/**
 * repeated PresetStudyPlanWeekly preset_study_plan_weeklies = 1;
 * @return {!Array<!proto.manabie.bob.PresetStudyPlanWeekly>}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.prototype.getPresetStudyPlanWeekliesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.PresetStudyPlanWeekly>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.PresetStudyPlanWeekly, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.PresetStudyPlanWeekly>} value */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.prototype.setPresetStudyPlanWeekliesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.PresetStudyPlanWeekly=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.PresetStudyPlanWeekly}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.prototype.addPresetStudyPlanWeeklies = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.PresetStudyPlanWeekly, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesRequest.prototype.clearPresetStudyPlanWeekliesList = function () {
  this.setPresetStudyPlanWeekliesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      presetStudyPlanWeeklyIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse();
  return proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addPresetStudyPlanWeeklyIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPresetStudyPlanWeeklyIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string preset_study_plan_weekly_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.prototype.getPresetStudyPlanWeeklyIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.prototype.setPresetStudyPlanWeeklyIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.prototype.addPresetStudyPlanWeeklyIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertPresetStudyPlanWeekliesResponse.prototype.clearPresetStudyPlanWeeklyIdsList = function () {
  this.setPresetStudyPlanWeeklyIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.UpsertQuizRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertQuizRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertQuizRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertQuizRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertQuizRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      quizsetsList: jspb.Message.toObjectList(msg.getQuizsetsList(), proto.manabie.bob.QuizSets.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertQuizRequest}
 */


proto.manabie.bob.UpsertQuizRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertQuizRequest();
  return proto.manabie.bob.UpsertQuizRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertQuizRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertQuizRequest}
 */


proto.manabie.bob.UpsertQuizRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.QuizSets();
        reader.readMessage(value, proto.manabie.bob.QuizSets.deserializeBinaryFromReader);
        msg.addQuizsets(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertQuizRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertQuizRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertQuizRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertQuizRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuizsetsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.QuizSets.serializeBinaryToWriter);
  }
};
/**
 * repeated QuizSets quizsets = 1;
 * @return {!Array<!proto.manabie.bob.QuizSets>}
 */


proto.manabie.bob.UpsertQuizRequest.prototype.getQuizsetsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.QuizSets>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.QuizSets, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.QuizSets>} value */


proto.manabie.bob.UpsertQuizRequest.prototype.setQuizsetsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.QuizSets=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.QuizSets}
 */


proto.manabie.bob.UpsertQuizRequest.prototype.addQuizsets = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.QuizSets, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.UpsertQuizRequest.prototype.clearQuizsetsList = function () {
  this.setQuizsetsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.UpsertQuizResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.UpsertQuizResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.UpsertQuizResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.UpsertQuizResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      successful: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.UpsertQuizResponse}
 */


proto.manabie.bob.UpsertQuizResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.UpsertQuizResponse();
  return proto.manabie.bob.UpsertQuizResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.UpsertQuizResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.UpsertQuizResponse}
 */


proto.manabie.bob.UpsertQuizResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {boolean} */
        reader.readBool();
        msg.setSuccessful(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.UpsertQuizResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.UpsertQuizResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.UpsertQuizResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.UpsertQuizResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuccessful();

  if (f) {
    writer.writeBool(1, f);
  }
};
/**
 * optional bool successful = 1;
 * @return {boolean}
 */


proto.manabie.bob.UpsertQuizResponse.prototype.getSuccessful = function () {
  return (
    /** @type {boolean} */
    jspb.Message.getBooleanFieldWithDefault(this, 1, false)
  );
};
/** @param {boolean} value */


proto.manabie.bob.UpsertQuizResponse.prototype.setSuccessful = function (value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.LocalGrade.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.LocalGrade.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.LocalGrade} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.LocalGrade.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      localGradeMap: (f = msg.getLocalGradeMap()) ? f.toObject(includeInstance, undefined) : []
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.LocalGrade}
 */


proto.manabie.bob.LocalGrade.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.LocalGrade();
  return proto.manabie.bob.LocalGrade.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.LocalGrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.LocalGrade}
 */


proto.manabie.bob.LocalGrade.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = msg.getLocalGradeMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "");
        });
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.LocalGrade.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.LocalGrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.LocalGrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.LocalGrade.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLocalGradeMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};
/**
 * map<string, int32> local_grade = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */


proto.manabie.bob.LocalGrade.prototype.getLocalGradeMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,number>} */
    jspb.Message.getMapField(this, 1, opt_noLazyCreate, null)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 */


proto.manabie.bob.LocalGrade.prototype.clearLocalGradeMap = function () {
  this.getLocalGradeMap().clear();
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveGradeMapResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveGradeMapResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveGradeMapResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveGradeMapResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      gradeMapMap: (f = msg.getGradeMapMap()) ? f.toObject(includeInstance, proto.manabie.bob.LocalGrade.toObject) : []
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveGradeMapResponse}
 */


proto.manabie.bob.RetrieveGradeMapResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveGradeMapResponse();
  return proto.manabie.bob.RetrieveGradeMapResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveGradeMapResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveGradeMapResponse}
 */


proto.manabie.bob.RetrieveGradeMapResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = msg.getGradeMapMap();
        reader.readMessage(value, function (message, reader) {
          jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.manabie.bob.LocalGrade.deserializeBinaryFromReader, "");
        });
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveGradeMapResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveGradeMapResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveGradeMapResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveGradeMapResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getGradeMapMap(true);

  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.manabie.bob.LocalGrade.serializeBinaryToWriter);
  }
};
/**
 * map<string, LocalGrade> grade_map = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.manabie.bob.LocalGrade>}
 */


proto.manabie.bob.RetrieveGradeMapResponse.prototype.getGradeMapMap = function (opt_noLazyCreate) {
  return (
    /** @type {!jspb.Map<string,!proto.manabie.bob.LocalGrade>} */
    jspb.Message.getMapField(this, 1, opt_noLazyCreate, proto.manabie.bob.LocalGrade)
  );
};
/**
 * Clears values from the map. The map will be non-null.
 */


proto.manabie.bob.RetrieveGradeMapResponse.prototype.clearGradeMapMap = function () {
  this.getGradeMapMap().clear();
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveGradeMapRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveGradeMapRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveGradeMapRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveGradeMapRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveGradeMapRequest}
 */


proto.manabie.bob.RetrieveGradeMapRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveGradeMapRequest();
  return proto.manabie.bob.RetrieveGradeMapRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveGradeMapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveGradeMapRequest}
 */


proto.manabie.bob.RetrieveGradeMapRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveGradeMapRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveGradeMapRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveGradeMapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveGradeMapRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetHistoryQuizDetailRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetHistoryQuizDetailRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetHistoryQuizDetailRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetHistoryQuizDetailRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      studentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      quizId: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetHistoryQuizDetailRequest}
 */


proto.manabie.bob.GetHistoryQuizDetailRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetHistoryQuizDetailRequest();
  return proto.manabie.bob.GetHistoryQuizDetailRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetHistoryQuizDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetHistoryQuizDetailRequest}
 */


proto.manabie.bob.GetHistoryQuizDetailRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setStudentId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setQuizId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetHistoryQuizDetailRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetHistoryQuizDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetHistoryQuizDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetHistoryQuizDetailRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getStudentId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getQuizId();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional string student_id = 1;
 * @return {string}
 */


proto.manabie.bob.GetHistoryQuizDetailRequest.prototype.getStudentId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetHistoryQuizDetailRequest.prototype.setStudentId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string quiz_id = 2;
 * @return {string}
 */


proto.manabie.bob.GetHistoryQuizDetailRequest.prototype.getQuizId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetHistoryQuizDetailRequest.prototype.setQuizId = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetHistoryQuizDetailResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetHistoryQuizDetailResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetHistoryQuizDetailResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      question: (f = msg.getQuestion()) && proto.manabie.bob.Question.toObject(includeInstance, f),
      selectedAnswer: jspb.Message.getFieldWithDefault(msg, 2, 0),
      displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetHistoryQuizDetailResponse}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetHistoryQuizDetailResponse();
  return proto.manabie.bob.GetHistoryQuizDetailResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetHistoryQuizDetailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetHistoryQuizDetailResponse}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Question();
        reader.readMessage(value, proto.manabie.bob.Question.deserializeBinaryFromReader);
        msg.setQuestion(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setSelectedAnswer(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDisplayOrder(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetHistoryQuizDetailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetHistoryQuizDetailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getQuestion();

  if (f != null) {
    writer.writeMessage(1, f, proto.manabie.bob.Question.serializeBinaryToWriter);
  }

  f = message.getSelectedAnswer();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }

  f = message.getDisplayOrder();

  if (f !== 0) {
    writer.writeInt32(3, f);
  }
};
/**
 * optional Question question = 1;
 * @return {?proto.manabie.bob.Question}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.getQuestion = function () {
  return (
    /** @type{?proto.manabie.bob.Question} */
    jspb.Message.getWrapperField(this, proto.manabie.bob.Question, 1)
  );
};
/** @param {?proto.manabie.bob.Question|undefined} value */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.setQuestion = function (value) {
  jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.clearQuestion = function () {
  this.setQuestion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.hasQuestion = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional int32 selected_answer = 2;
 * @return {number}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.getSelectedAnswer = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.setSelectedAnswer = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 display_order = 3;
 * @return {number}
 */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.getDisplayOrder = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.GetHistoryQuizDetailResponse.prototype.setDisplayOrder = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.SuggestLORequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.SuggestLORequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.SuggestLORequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.SuggestLORequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      loName: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.SuggestLORequest}
 */


proto.manabie.bob.SuggestLORequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.SuggestLORequest();
  return proto.manabie.bob.SuggestLORequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.SuggestLORequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.SuggestLORequest}
 */


proto.manabie.bob.SuggestLORequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setLoName(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.SuggestLORequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.SuggestLORequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.SuggestLORequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.SuggestLORequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getLoName();

  if (f.length > 0) {
    writer.writeString(1, f);
  }
};
/**
 * optional string lo_name = 1;
 * @return {string}
 */


proto.manabie.bob.SuggestLORequest.prototype.getLoName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.SuggestLORequest.prototype.setLoName = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.SuggestLOResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.SuggestLOResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.SuggestLOResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.SuggestLOResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.SuggestLOResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      suggestLosList: jspb.Message.toObjectList(msg.getSuggestLosList(), proto.manabie.bob.LearningObjective.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.SuggestLOResponse}
 */


proto.manabie.bob.SuggestLOResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.SuggestLOResponse();
  return proto.manabie.bob.SuggestLOResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.SuggestLOResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.SuggestLOResponse}
 */


proto.manabie.bob.SuggestLOResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.LearningObjective();
        reader.readMessage(value, proto.manabie.bob.LearningObjective.deserializeBinaryFromReader);
        msg.addSuggestLos(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.SuggestLOResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.SuggestLOResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.SuggestLOResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.SuggestLOResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getSuggestLosList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.LearningObjective.serializeBinaryToWriter);
  }
};
/**
 * repeated LearningObjective suggest_los = 1;
 * @return {!Array<!proto.manabie.bob.LearningObjective>}
 */


proto.manabie.bob.SuggestLOResponse.prototype.getSuggestLosList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.LearningObjective>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.LearningObjective, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.LearningObjective>} value */


proto.manabie.bob.SuggestLOResponse.prototype.setSuggestLosList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.LearningObjective=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.LearningObjective}
 */


proto.manabie.bob.SuggestLOResponse.prototype.addSuggestLos = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.LearningObjective, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.SuggestLOResponse.prototype.clearSuggestLosList = function () {
  this.setSuggestLosList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.PublishTopicsRequest.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PublishTopicsRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PublishTopicsRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PublishTopicsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PublishTopicsRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      topicIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PublishTopicsRequest}
 */


proto.manabie.bob.PublishTopicsRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PublishTopicsRequest();
  return proto.manabie.bob.PublishTopicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PublishTopicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PublishTopicsRequest}
 */


proto.manabie.bob.PublishTopicsRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.addTopicIds(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PublishTopicsRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PublishTopicsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PublishTopicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PublishTopicsRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTopicIdsList();

  if (f.length > 0) {
    writer.writeRepeatedString(1, f);
  }
};
/**
 * repeated string topic_ids = 1;
 * @return {!Array<string>}
 */


proto.manabie.bob.PublishTopicsRequest.prototype.getTopicIdsList = function () {
  return (
    /** @type {!Array<string>} */
    jspb.Message.getRepeatedField(this, 1)
  );
};
/** @param {!Array<string>} value */


proto.manabie.bob.PublishTopicsRequest.prototype.setTopicIdsList = function (value) {
  jspb.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 */


proto.manabie.bob.PublishTopicsRequest.prototype.addTopicIds = function (value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.PublishTopicsRequest.prototype.clearTopicIdsList = function () {
  this.setTopicIdsList([]);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.PublishTopicsResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.PublishTopicsResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.PublishTopicsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.PublishTopicsResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {};

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.PublishTopicsResponse}
 */


proto.manabie.bob.PublishTopicsResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.PublishTopicsResponse();
  return proto.manabie.bob.PublishTopicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.PublishTopicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.PublishTopicsResponse}
 */


proto.manabie.bob.PublishTopicsResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.PublishTopicsResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.PublishTopicsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.PublishTopicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.PublishTopicsResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.Chapter.repeatedFields_ = [7];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.Chapter.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.Chapter.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.Chapter} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.Chapter.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      chapterId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      chapterName: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      subject: jspb.Message.getFieldWithDefault(msg, 4, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 5, ""),
      displayOrder: jspb.Message.getFieldWithDefault(msg, 6, 0),
      topicsList: jspb.Message.toObjectList(msg.getTopicsList(), proto.manabie.bob.Topic.toObject, includeInstance),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.Chapter}
 */


proto.manabie.bob.Chapter.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.Chapter();
  return proto.manabie.bob.Chapter.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.Chapter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.Chapter}
 */


proto.manabie.bob.Chapter.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChapterId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChapterName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setDisplayOrder(value);
        break;

      case 7:
        var value = new proto.manabie.bob.Topic();
        reader.readMessage(value, proto.manabie.bob.Topic.deserializeBinaryFromReader);
        msg.addTopics(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 9:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.Chapter.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.Chapter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.Chapter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.Chapter.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getChapterId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getChapterName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getDisplayOrder();

  if (f !== 0) {
    writer.writeInt32(6, f);
  }

  f = message.getTopicsList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(7, f, proto.manabie.bob.Topic.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(9, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string chapter_id = 1;
 * @return {string}
 */


proto.manabie.bob.Chapter.prototype.getChapterId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Chapter.prototype.setChapterId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string chapter_name = 2;
 * @return {string}
 */


proto.manabie.bob.Chapter.prototype.getChapterName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Chapter.prototype.setChapterName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.Chapter.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.Chapter.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional Subject subject = 4;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.Chapter.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.Chapter.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional string grade = 5;
 * @return {string}
 */


proto.manabie.bob.Chapter.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.Chapter.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 display_order = 6;
 * @return {number}
 */


proto.manabie.bob.Chapter.prototype.getDisplayOrder = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.Chapter.prototype.setDisplayOrder = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * repeated Topic topics = 7;
 * @return {!Array<!proto.manabie.bob.Topic>}
 */


proto.manabie.bob.Chapter.prototype.getTopicsList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Topic>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Topic, 7)
  );
};
/** @param {!Array<!proto.manabie.bob.Topic>} value */


proto.manabie.bob.Chapter.prototype.setTopicsList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.manabie.bob.Topic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Topic}
 */


proto.manabie.bob.Chapter.prototype.addTopics = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.manabie.bob.Topic, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.Chapter.prototype.clearTopicsList = function () {
  this.setTopicsList([]);
};
/**
 * optional google.protobuf.Timestamp updated_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Chapter.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Chapter.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Chapter.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Chapter.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.Chapter.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.Chapter.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.Chapter.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.Chapter.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 9) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetChapterListRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetChapterListRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetChapterListRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetChapterListRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      chapterId: jspb.Message.getFieldWithDefault(msg, 1, ""),
      chapterName: jspb.Message.getFieldWithDefault(msg, 2, ""),
      limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
      page: jspb.Message.getFieldWithDefault(msg, 4, 0),
      subject: jspb.Message.getFieldWithDefault(msg, 5, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 6, ""),
      country: jspb.Message.getFieldWithDefault(msg, 7, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetChapterListRequest}
 */


proto.manabie.bob.GetChapterListRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetChapterListRequest();
  return proto.manabie.bob.GetChapterListRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetChapterListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetChapterListRequest}
 */


proto.manabie.bob.GetChapterListRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChapterId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setChapterName(value);
        break;

      case 3:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setLimit(value);
        break;

      case 4:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setPage(value);
        break;

      case 5:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 6:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 7:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetChapterListRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetChapterListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetChapterListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetChapterListRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getChapterId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getChapterName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getLimit();

  if (f !== 0) {
    writer.writeUint32(3, f);
  }

  f = message.getPage();

  if (f !== 0) {
    writer.writeUint32(4, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(5, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(6, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(7, f);
  }
};
/**
 * optional string chapter_id = 1;
 * @return {string}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getChapterId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetChapterListRequest.prototype.setChapterId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string chapter_name = 2;
 * @return {string}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getChapterName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetChapterListRequest.prototype.setChapterName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional uint32 limit = 3;
 * @return {number}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getLimit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.GetChapterListRequest.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional uint32 page = 4;
 * @return {number}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getPage = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.GetChapterListRequest.prototype.setPage = function (value) {
  jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional Subject subject = 5;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 5, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.GetChapterListRequest.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional string grade = 6;
 * @return {string}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 6, "")
  );
};
/** @param {string} value */


proto.manabie.bob.GetChapterListRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 6, value);
};
/**
 * optional Country country = 7;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.GetChapterListRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.GetChapterListRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.GetChapterListResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.GetChapterListResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.GetChapterListResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.GetChapterListResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.GetChapterListResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      chaptersList: jspb.Message.toObjectList(msg.getChaptersList(), proto.manabie.bob.Chapter.toObject, includeInstance),
      total: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.GetChapterListResponse}
 */


proto.manabie.bob.GetChapterListResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.GetChapterListResponse();
  return proto.manabie.bob.GetChapterListResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.GetChapterListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.GetChapterListResponse}
 */


proto.manabie.bob.GetChapterListResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.Chapter();
        reader.readMessage(value, proto.manabie.bob.Chapter.deserializeBinaryFromReader);
        msg.addChapters(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readUint32();
        msg.setTotal(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.GetChapterListResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.GetChapterListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.GetChapterListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.GetChapterListResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getChaptersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.Chapter.serializeBinaryToWriter);
  }

  f = message.getTotal();

  if (f !== 0) {
    writer.writeUint32(2, f);
  }
};
/**
 * repeated Chapter chapters = 1;
 * @return {!Array<!proto.manabie.bob.Chapter>}
 */


proto.manabie.bob.GetChapterListResponse.prototype.getChaptersList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Chapter>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Chapter, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.Chapter>} value */


proto.manabie.bob.GetChapterListResponse.prototype.setChaptersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.Chapter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Chapter}
 */


proto.manabie.bob.GetChapterListResponse.prototype.addChapters = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.Chapter, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.GetChapterListResponse.prototype.clearChaptersList = function () {
  this.setChaptersList([]);
};
/**
 * optional uint32 total = 2;
 * @return {number}
 */


proto.manabie.bob.GetChapterListResponse.prototype.getTotal = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.GetChapterListResponse.prototype.setTotal = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCoursesRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCoursesRequest.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCoursesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCoursesRequest.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      subject: jspb.Message.getFieldWithDefault(msg, 4, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 5, ""),
      limit: jspb.Message.getFieldWithDefault(msg, 6, 0),
      page: jspb.Message.getFieldWithDefault(msg, 7, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCoursesRequest}
 */


proto.manabie.bob.RetrieveCoursesRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCoursesRequest();
  return proto.manabie.bob.RetrieveCoursesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCoursesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCoursesRequest}
 */


proto.manabie.bob.RetrieveCoursesRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 6:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setLimit(value);
        break;

      case 7:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setPage(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCoursesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCoursesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCoursesRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getLimit();

  if (f !== 0) {
    writer.writeInt32(6, f);
  }

  f = message.getPage();

  if (f !== 0) {
    writer.writeInt32(7, f);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional Subject subject = 4;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional string grade = 5;
 * @return {string}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 limit = 6;
 * @return {number}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getLimit = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 6, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setLimit = function (value) {
  jspb.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 page = 7;
 * @return {number}
 */


proto.manabie.bob.RetrieveCoursesRequest.prototype.getPage = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 7, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveCoursesRequest.prototype.setPage = function (value) {
  jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveCoursesResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCoursesResponse.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCoursesResponse.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCoursesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCoursesResponse.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      coursesList: jspb.Message.toObjectList(msg.getCoursesList(), proto.manabie.bob.RetrieveCoursesResponse.Course.toObject, includeInstance),
      total: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCoursesResponse}
 */


proto.manabie.bob.RetrieveCoursesResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCoursesResponse();
  return proto.manabie.bob.RetrieveCoursesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCoursesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCoursesResponse}
 */


proto.manabie.bob.RetrieveCoursesResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.manabie.bob.RetrieveCoursesResponse.Course();
        reader.readMessage(value, proto.manabie.bob.RetrieveCoursesResponse.Course.deserializeBinaryFromReader);
        msg.addCourses(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setTotal(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCoursesResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCoursesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCoursesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCoursesResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCoursesList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.manabie.bob.RetrieveCoursesResponse.Course.serializeBinaryToWriter);
  }

  f = message.getTotal();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.repeatedFields_ = [6];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.toObject = function (opt_includeInstance) {
    return proto.manabie.bob.RetrieveCoursesResponse.Course.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.manabie.bob.RetrieveCoursesResponse.Course} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.manabie.bob.RetrieveCoursesResponse.Course.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, 0),
      subject: jspb.Message.getFieldWithDefault(msg, 4, 0),
      grade: jspb.Message.getFieldWithDefault(msg, 5, ""),
      chaptersList: jspb.Message.toObjectList(msg.getChaptersList(), proto.manabie.bob.Chapter.toObject, includeInstance),
      updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.manabie.bob.RetrieveCoursesResponse.Course}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.manabie.bob.RetrieveCoursesResponse.Course();
  return proto.manabie.bob.RetrieveCoursesResponse.Course.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.manabie.bob.RetrieveCoursesResponse.Course} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.manabie.bob.RetrieveCoursesResponse.Course}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setId(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setName(value);
        break;

      case 3:
        var value =
        /** @type {!proto.manabie.bob.Country} */
        reader.readEnum();
        msg.setCountry(value);
        break;

      case 4:
        var value =
        /** @type {!proto.manabie.bob.Subject} */
        reader.readEnum();
        msg.setSubject(value);
        break;

      case 5:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setGrade(value);
        break;

      case 6:
        var value = new proto.manabie.bob.Chapter();
        reader.readMessage(value, proto.manabie.bob.Chapter.deserializeBinaryFromReader);
        msg.addChapters(value);
        break;

      case 7:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setUpdatedAt(value);
        break;

      case 8:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setCreatedAt(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.manabie.bob.RetrieveCoursesResponse.Course.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.manabie.bob.RetrieveCoursesResponse.Course} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f.length > 0) {
    writer.writeString(1, f);
  }

  f = message.getName();

  if (f.length > 0) {
    writer.writeString(2, f);
  }

  f = message.getCountry();

  if (f !== 0.0) {
    writer.writeEnum(3, f);
  }

  f = message.getSubject();

  if (f !== 0.0) {
    writer.writeEnum(4, f);
  }

  f = message.getGrade();

  if (f.length > 0) {
    writer.writeString(5, f);
  }

  f = message.getChaptersList();

  if (f.length > 0) {
    writer.writeRepeatedMessage(6, f, proto.manabie.bob.Chapter.serializeBinaryToWriter);
  }

  f = message.getUpdatedAt();

  if (f != null) {
    writer.writeMessage(7, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getCreatedAt();

  if (f != null) {
    writer.writeMessage(8, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
};
/**
 * optional string id = 1;
 * @return {string}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getId = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 1, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setId = function (value) {
  jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getName = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setName = function (value) {
  jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Country country = 3;
 * @return {!proto.manabie.bob.Country}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getCountry = function () {
  return (
    /** @type {!proto.manabie.bob.Country} */
    jspb.Message.getFieldWithDefault(this, 3, 0)
  );
};
/** @param {!proto.manabie.bob.Country} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setCountry = function (value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional Subject subject = 4;
 * @return {!proto.manabie.bob.Subject}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getSubject = function () {
  return (
    /** @type {!proto.manabie.bob.Subject} */
    jspb.Message.getFieldWithDefault(this, 4, 0)
  );
};
/** @param {!proto.manabie.bob.Subject} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setSubject = function (value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional string grade = 5;
 * @return {string}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getGrade = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 5, "")
  );
};
/** @param {string} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setGrade = function (value) {
  jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * repeated Chapter chapters = 6;
 * @return {!Array<!proto.manabie.bob.Chapter>}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getChaptersList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.Chapter>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.Chapter, 6)
  );
};
/** @param {!Array<!proto.manabie.bob.Chapter>} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setChaptersList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.manabie.bob.Chapter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.Chapter}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.addChapters = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.manabie.bob.Chapter, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.clearChaptersList = function () {
  this.setChaptersList([]);
};
/**
 * optional google.protobuf.Timestamp updated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getUpdatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setUpdatedAt = function (value) {
  jspb.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.clearUpdatedAt = function () {
  this.setUpdatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.hasUpdatedAt = function () {
  return jspb.Message.getField(this, 7) != null;
};
/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.getCreatedAt = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8)
  );
};
/** @param {?proto.google.protobuf.Timestamp|undefined} value */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.setCreatedAt = function (value) {
  jspb.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.clearCreatedAt = function () {
  this.setCreatedAt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.manabie.bob.RetrieveCoursesResponse.Course.prototype.hasCreatedAt = function () {
  return jspb.Message.getField(this, 8) != null;
};
/**
 * repeated Course courses = 1;
 * @return {!Array<!proto.manabie.bob.RetrieveCoursesResponse.Course>}
 */


proto.manabie.bob.RetrieveCoursesResponse.prototype.getCoursesList = function () {
  return (
    /** @type{!Array<!proto.manabie.bob.RetrieveCoursesResponse.Course>} */
    jspb.Message.getRepeatedWrapperField(this, proto.manabie.bob.RetrieveCoursesResponse.Course, 1)
  );
};
/** @param {!Array<!proto.manabie.bob.RetrieveCoursesResponse.Course>} value */


proto.manabie.bob.RetrieveCoursesResponse.prototype.setCoursesList = function (value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.manabie.bob.RetrieveCoursesResponse.Course=} opt_value
 * @param {number=} opt_index
 * @return {!proto.manabie.bob.RetrieveCoursesResponse.Course}
 */


proto.manabie.bob.RetrieveCoursesResponse.prototype.addCourses = function (opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.manabie.bob.RetrieveCoursesResponse.Course, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 */


proto.manabie.bob.RetrieveCoursesResponse.prototype.clearCoursesList = function () {
  this.setCoursesList([]);
};
/**
 * optional int32 total = 2;
 * @return {number}
 */


proto.manabie.bob.RetrieveCoursesResponse.prototype.getTotal = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/** @param {number} value */


proto.manabie.bob.RetrieveCoursesResponse.prototype.setTotal = function (value) {
  jspb.Message.setProto3IntField(this, 2, value);
};

goog.object.extend(exports, proto.manabie.bob);